// src/screens/settings/master/accessories/AccessoryCategoriesPage.jsx
import React from "react";
import MasterDataListPage from "../MasterDataListPage";
import { createHttpClient } from "../../../api/client"; // ปรับ path ให้ตรงโปรเจกต์คุณ

export default function AccessoryCategoriesPage() {
    const http = React.useMemo(() => createHttpClient(), []);

    return (
        <MasterDataListPage
            title="Master Data"
            subtitle="ประเภทอุปกรณ์เสริม"
            apiPath="/accessories"
            fieldKey="name"
            createDefaultName="รายการใหม่"
            initialItems={[]}
            showSubButton
            subLabel="เพิ่มแบรนด์"
            subRouteBuilder={(cat) => `/app/settings/master/accessories/${cat.id}/models`}
            showSubDropdown
            subTitle="แบรนด์ทั้งหมด"
            subFieldKey="name"
            subListFetcher={async (cat) => {
                const res = await http.get("/brands", {
                    params: {
                        filters: { accessory: { id: { $eq: cat.id } } },
                        sort: ["id:desc"],
                        pagination: { pageSize: 200 },
                    },
                });

                return res?.data?.data || [];
            }}
        />
    );
}